export interface NavLink {
  label: string;
  href: string;
  external?: boolean;
}

export const MORE_LABEL = 'Ещё…';

export const PRIMARY_NAV_LINKS: NavLink[] = [
  { label: 'Горящие туры', href: '/tury' },
  { label: 'Поиск отелей', href: '/hotels/search' },
  { label: 'Поиск туров', href: '/search' },
  { label: 'Отдых в России', href: '/russia' },
  {
    label: 'Турагентствам',
    href: 'https://travelata-promo.ru/travelata-for-agencies',
    external: true,
  },
];

export const MORE_NAV_LINKS: NavLink[] = [
  { label: 'О нас', href: '/about' },
  { label: 'Франчайзи', href: '/franchising' },
  { label: 'Рейтинг туроператоров', href: '/rating' },
  { label: 'Раннее бронирование', href: '/earlybooking' },
  { label: 'Все отели', href: '/hotels' },
  { label: 'ЖД туры по России', href: '/railways/search' },
  { label: 'Календарь низких цен', href: '/calendar' },
  { label: 'Туры на выходные', href: '/weekend-tours/russia' },
  { label: 'Горнолыжные', href: '/ski' },
  { label: 'Отдых с детьми', href: '/kids' },
  { label: 'Туры на Новый год', href: '/newyear-tours' },
  { label: 'Оплата', href: '/sposoby-oplaty' },
  { label: 'Блог', href: '//travelata.ru/blog/' },
  { label: 'Пресса о нас', href: '/press.html' },
  {
    label: 'Подарочные сертификаты',
    href: 'https://gift.travelata.ru/?utm_source=travelata&utm_medium=menu&utm_campaign=gift_certificates&utm_content=header',
  },
  { label: 'Частые вопросы', href: '/faq' },
];
